import React, {Component} from 'react';
import {authService} from "../../../auth";
import {NavLink} from "react-router-dom";


class UnAuthSkillsPopUp extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage()
        }
    }

    componentWillUnmount() {
        window.$("#unauthprojectPopup").modal("hide");
    }

    render() {
        return (
            <div id="unauthprojectPopup" className="modal fade dgpopup reqendorse" data-backdrop="static"
                 data-keyboard="false">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="profcolwidget">
                                <li>
                                    <NavLink to="/">
                                        <button className="close"><i className="iCross"></i></button>
                                    </NavLink>
                                </li>
                                <div className="profcolwidgetdesc">
                                    <h4>Member has kept this project as private</h4>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




export default UnAuthSkillsPopUp;

